import { Container, styled } from '@mui/material';

export const Wrapper = styled(Container)`
  &.MuiContainer-root {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
